import React from 'react';
import CSSModules from 'react-css-modules';
import classnames from 'classnames/bind';

import stylingUtils from '../../services/stylingUtilities';

import style from './style.scss';

class MaterialIcon extends React.Component {
    _getClassName() {
        const cx = classnames.bind(style);

        const baseStyle = {
            'material-icons': true
        };

        return cx(stylingUtils.mergeClassNames(baseStyle, this.props.className));
    }

    _mapTypeToCharacterReference(type) {
        const mapping = {
            description: '&#xE873',
            clear: '&#xE14C;',
            file_download: '&#xE2C4;',
            forum: '&#xE0BF;',
            settings: '&#xE8B8;',
            person_add: '&#xE7FE;',
            keyboard_arrow_down: '&#xE313;',
            add: '&#xE145;',
            chat_bubble_outline: '&#xE0CB;',
            access_time: '&#xE192;',
            comment: '&#xE0B9;',
            edit: '&#xE3C9;',
            dns: '&#xE875;',
            attachment: '&#xE2BC;',
            reply: '&#xE15E;',
            notification: '&#xE7F4;',
            notifications_none: '&#xE7F5;',
            format_bold: '&#xE238;',
            format_italic: '&#xE23F;',
            format_underline: '&#xE249;',
            format_list_bulleted: '&#xE241;',
            format_list_numbered: '&#xE242;',
            format_indent_increase: '&#xE23E;',
            format_indent_decrease: '&#xE23D;',
            insert_link: '&#xE250;',
            stars: '&#xE8D0;',
            menu: '&#xE5D2;',
            chevron_right: '&#xE315;',
            add_box: '&#xE146;',
            indeterminate_check_box: '&#xE909',
            check: '&#xE5CA;',
            highlight_off: '&#xE888'
        };

        return mapping[type] ? mapping[type] : type;
    }

    render() {
        return (
            <i
                {...this.props}
                className={this._getClassName()}
                aria-hidden="true"
                dangerouslySetInnerHTML={{ __html: this._mapTypeToCharacterReference(this.props.type) }}
            />
        );
    }
}

MaterialIcon.defaultProps = {
    onClick: () => {}
};

export default CSSModules(MaterialIcon, style);



// WEBPACK FOOTER //
// ./components/MaterialIcon/index.js